import React, {useEffect, useState} from 'react';
import parent from '../MyModal/MyModal.module.css'
import cl from './PeriodModal.module.css'
import close from "../../../Assets/icons/clear.svg";
import delete_icon from '../../../Assets/icons/delete.svg'
import {format, parseISO} from "date-fns";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { DateRange } from "react-date-range";
import enUS from 'date-fns/locale/en-US';
import styles from '../../../styles/dateRangeOverrides.css'

const PeriodModal = ({visible, setVisible, startDate, setStartDate, endDate, setEndDate}) => {
    const rootClasses = [parent.myModal]

    if (visible){
        rootClasses.push(parent.active);
    }

    const reset = () => {
        setEndDate("");
        setStartDate("");
        setRange([
            {
                startDate: new Date(),
                endDate: new Date(),
                key: "selection",
            },
        ]);
    }

    const [range, setRange] = useState([
        {
            startDate: new Date(),
            endDate: new Date(),
            key: "selection",
        },
    ]);

    useEffect(() => {
        if (visible) {
            setRange([
                {
                    startDate: startDate ? parseISO(startDate) : new Date(),
                    endDate: endDate ? parseISO(endDate) : new Date(),
                    key: "selection",
                },
            ]);
        }
    }, [visible]);

    const handleApply = () => {
        const start = format(range[0].startDate, "yyyy-MM-dd");
        const end = format(range[0].endDate, "yyyy-MM-dd");

        setStartDate(start);
        setEndDate(end);
        setVisible(false);
    };

    const handleCancel = () => {
        setRange([
            {
                startDate: new Date(),
                endDate: new Date(),
                key: "selection",
            },
        ]);
        setStartDate("");
        setEndDate("");
    };

    return (
        <div
            className={rootClasses.join(' ')}
            onClick={() => setVisible(false)}
        >
            <div
                className={cl.content}
                onClick={(e) => e.stopPropagation()}
            >
                <div className={cl.header}>
                    <p>
                        Select period
                    </p>
                    <img src={close} onClick={() => setVisible(false)} alt={"X"}/>
                </div>
                <div className={cl.mainBlock}>
                    <div className={cl.selectedDate}>
                        <div className={cl.dates}>
                            {format(range[0].startDate, 'dd.MM.yyyy') && format(range[0].endDate, 'dd.MM.yyyy')
                                ? `${format(range[0].startDate, 'dd.MM.yyyy')} - ${format(range[0].endDate, 'dd.MM.yyyy')}`
                                : '... - ...'}
                        </div>
                        <img
                            src={delete_icon}
                            alt={"delete"}
                            onClick={reset}
                        />
                    </div>
                    <div className={styles.PeriodModalWrapper}>
                        <DateRange
                            editableDateInputs={true}
                            onChange={(item) => {
                                setRange([item.selection]);

                            }}
                            moveRangeOnFirstSelection={false}
                            ranges={range}
                            locale={enUS}
                            showDateDisplay={false}
                        />
                    </div>

                    <div className={cl.buttons}>
                        <button
                            className={cl.apply}
                            onClick={handleApply}
                        >
                            Apply
                        </button>
                        <button
                            className={cl.cancel}
                            onClick={handleCancel}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PeriodModal;